import React from 'react';

import { CircledDottedScheme } from '../components/CircledDottedScheme';
import { CircledDottedSchemeProps } from '../components/CircledDottedSchemeDesktop';

import './CircledDottedScheme8.scss';

const CircledDottedScheme8 = (props: CircledDottedSchemeProps) => <CircledDottedScheme {...props} />;

export default CircledDottedScheme8;
